import React from 'react';
import { Box, Text, SimpleGrid } from '@chakra-ui/react';
import TemplateCard from './TemplateCard';
import TEMPLATES from './templateConfig';

const TemplateGallery = ({ onTemplateSelect }) => {
  return (
    <Box
      h="100%"
      w="100%"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      px={8}
      pt={6}
      pb={8}
      overflow="auto"
    >
      <Box mb={5}>
        <Text
          fontSize="md"
          fontWeight="600"
          color="white"
          letterSpacing="-0.01em"
          mb={1}
        >
          Playbooks for financial advisors
        </Text>
        <Text fontSize="xs" color="gray.500">
          Start from households tied to home transitions, liquidity events, or inheritances—or
          describe your ideal client in chat
        </Text>
      </Box>

      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3 }}
        spacing={5}
        w="100%"
        maxW="1200px"
      >
        {TEMPLATES.map((template) => (
          <TemplateCard
            key={template.id}
            template={template}
            onClick={onTemplateSelect}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default TemplateGallery;
